<template>
	<div class="iframe-container-box container">
		<div class="header">
			<rs-row>
				<rs-col :span="24">
					<div class="grid-content bg-purple-dark">
						<span style="margin-left: 10px">对账管理</span>
					</div>
				</rs-col>
			</rs-row>
		</div>
		<div class="main">
			<rs-row style="min-height: 600px">
				<div class="main_header">
				<div class="searchForm" style="margin-top: 10px;">
					<renderForm :list="ruleForm" size="small" :formData.sync="searchForm" ref="ruleFormRef"
							label-width='100%'>
							<!-- <rs-form-item label="合同号"  minWidth="60px" slot="mallName">
								<rs-select @change="handleSearch" filterable v-model="searchForm.contractCode" placeholder="请选择">
									<rs-option v-for="item in Contract" :key="item.value" :label="item" :value="item">
									</rs-option>
								</rs-select>
							</rs-form-item> -->
							<rs-form-item label="支付方式:" slot="ccontractCode" width="70px">
								<rs-select @change='boothCodes' filterable v-model="searchForm.payType" placeholder="请选择">
									<rs-option v-for="item in ccontractCode" :key="item.payType" :label="item.label"
										:value="item.payType">
									</rs-option>
								</rs-select>
							</rs-form-item>
				<rs-form-item label="交易状态:" slot="type" width="70px">
								<rs-select filterable placeholder="请选择" v-model="searchForm.tradeStatus">
									<rs-option v-for="item in Type" :key="item.tradeStatus" :label="item.label" :value="item.tradeStatus">
									</rs-option>
								</rs-select>
							</rs-form-item>
					<rs-form-item label="支付时间:" min slot="date">
								<rs-date-picker v-model="beginDate " type="daterange" range-separator="-"
								@change='change'
								value-format="yyyy-MM-dd" format="yyyy-MM-dd"
									start-placeholder="开始时间"  end-placeholder="结束时间"
									size="mini" class="margin-right-10">
								</rs-date-picker>
							</rs-form-item>
						</renderForm>
						<div style="margin-left: 80%; position: relative; top: -45px">
							<rs-button type="primary" size="small" @click="handleSearch">查询</rs-button>
							<rs-button type="text" size="small" @click="clear">重置</rs-button>
						</div>
					</div>
				<!-- 		<div class="contractCode">
            <div>
              <div>待缴总金额（元）</div>
              <div class="contractCodecolor">
                {{ amountpaid }} <span></span>
              </div>
            </div>
            <div>
              <div>当期缴费金额(元)</div>
              <div>{{ Currentnumber }} <span></span></div>
            </div>
            <div>
              <div>已缴总金额（元）</div>
              <div>{{ PaidAmount }} <span></span></div>
            </div>
            <div>
              <div>缴费记录</div>
              <div>{{ PayNum }}</div>
            </div>
          </div> -->
					</div>
				<div class="main_main" style="background: #fff; box-shadow: 2px 2px 10px #909090;margin-top: 50px;">

					<!-- 操作栏 -->
					<!-- <div class="operBox"></div> -->
					<!-- 表格 -->
					<rs-button
						style="float: right; margin-left: 0%;margin-right: 20px;margin-bottom: 10px;margin-top: 20px;"
						@click="export2Excel">下载
					</rs-button>
					<div class="resultContent" style="margin-top: -45px;padding: 20px;">
						<rs-table :data='tableData' border @row-dblclick="handleView"
							@selection-change="handleSelectionChange">
							<rs-table-column type="selection" width="50px">
							</rs-table-column>
							<rs-table-column label='序号' type="index" width="50px">
							</rs-table-column>
							<rs-table-column header-align='center' align='center' show-overflow-tooltip label="铺位号"
								slot="buildingName">
								<template slot-scope="scope">
									{{ scope.row.booths }}
								</template>
							</rs-table-column>
							<rs-table-column prop='buildings' label="楼栋" show-overflow-tooltip align="center">

							</rs-table-column>
							<rs-table-column prop='floors' label="楼层" show-overflow-tooltip align="center">

							</rs-table-column>
							<rs-table-column label="订单金额" align="center">
								<template slot-scope="scope">
									{{ scope.row.orderAmt/100 }}
								</template>
							</rs-table-column>
							<rs-table-column align='center' label="支付金额">
								<template slot-scope="scope">
									{{ scope.row.payAmt/100 }}
								</template>
							</rs-table-column>
							<rs-table-column prop='merOrderNo' label="订单流水号(商户单号)" show-overflow-tooltip align="center">
							</rs-table-column>
							<rs-table-column prop='payType' label="支付方式" :formatter='formatCarModelsss'
								show-overflow-tooltip align="center">

							</rs-table-column>
							<rs-table-column prop='chlSubActNo' label="付款账户" show-overflow-tooltip align="center">

							</rs-table-column>
							<rs-table-column prop='accountNumber' label="收款账户" show-overflow-tooltip align="center">

							</rs-table-column>
							<rs-table-column :formatter='formatCarModels' label="交易状态" prop='tradeStatus'
								header-align='center' align='center'>
							</rs-table-column>
							<rs-table-column :formatter='formatCarModelss' label="对账状态" prop='verifyStatus'
								header-align='center' align='center'>
							</rs-table-column>
							<rs-table-column align="center" label="支付时间">
								<template slot-scope="scope">
									{{ scope.row.transTime }}
								</template>
							</rs-table-column>

							<!-- <rs-table-column prop='contractCode' label="合同号" show-overflow-tooltip align="center"  width="160px"> -->
							<!-- 	<template slot-scope="scope">
										<span @dbclick.stop="toDetails(scope.row.id)"
											style="cursor: pointer">{{ scope.row.contractCode }}</span>
									</template> -->
							<!-- </rs-table-column> -->
						</rs-table>
						<!-- <renderTable lazy style="padding: 10px" class="row-click" :list="tableData" :columns="tableColumns"
							border ref="multipleTable" @row-dblclick="handleView"
							@selection-change="handleSelectionChange">
							<rs-table-column type="selection" width="155px">
							</rs-table-column> -->

						<!-- :formatter='formatCarModels' -->
						<!-- <rs-table-column header-align='center' align='center'  label="项目"  width="160px"  slot='mallCode'>
							 	
							 </rs-table-column>
							 -->
						<!-- <rs-table-column label="合同号" show-overflow-tooltip align="center" slot="contractCode" sortable width="160px">
								<template slot-scope="scope">
									<span @dbclick.stop="toDetails(scope.row.id)"
										style="cursor: pointer">{{ scope.row.contractCode }}</span>
								</template>
							</rs-table-column>
							
							<rs-table-column label="铺位号" slot="boothCode" width="160px" show-overflow-tooltip>
								<template slot-scope="scope">
									<span v-for="(item, index) in scope.row.boothList" :key="index">
										<span v-if="index != 0">|</span>
										{{ item.boothCode }}
									</span>
								</template>
							</rs-table-column>
<rs-table-column :formatter='formatCarModels' label="交易状态" prop='tradeStatus'
										header-align='center' align='center' slot="tradeStatus">
									</rs-table-column>
									<rs-table-column :formatter='formatCarModelss' label="对账状态" prop='verifyStatus'
																			header-align='center' align='center' slot="type">
																		</rs-table-column>
							<rs-table-column label="店铺名称" slot="shopName" width="160px">
								<template slot-scope="scope">
									{{ scope.row.shopName }}
								</template>
							</rs-table-column>
<rs-table-column align='center' label="支付金额" slot="payAmt" width="160px">
								<template slot-scope="scope">
									{{ scope.row.payAmt/100 }}
								</template>
							</rs-table-column>
							<rs-table-column label="操作" slot="operation" fixed="right" width="240px">
								<template slot-scope="scope"> </template>
							</rs-table-column>
						</renderTable> -->
						<!-- 分页 -->
						<rs-pagination style="padding: 20px;" @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page="pageNum"
							:page-sizes="[10, 200, 300, 400]" :page-size="pageSize" background :prev-text="'上一页'"
							:next-text="'下一页'" layout="total,prev, pager, next, sizes, jumper" :total="total">
						</rs-pagination>
					</div>
				</div>
				<rs-dialog title="确认" :visible.sync="dialogVisible" width="30%">
					<h2 style="text-align: center; margin: 0">
						{{ `确认${confirmType}吗？` }}
					</h2>
					<span slot="footer" class="dialog-footer">
						<rs-button @click="dialogVisible = false">取 消</rs-button>
						<rs-button type="primary" @click="confirm">确 定</rs-button>
					</span>
				</rs-dialog>
				<!-- <change-type-dialog :path="path" :contractId="contractId" :dialogVisible="showChangeTypeDialog" @close="
            () => {
              this.showChangeTypeDialog = false;
            }
          ">
				</change-type-dialog> -->
			</rs-row>
		</div>
		<rs-dialog title="扫码支付" :visible.sync="dialogVisibles" width="30%" :before-close="handleClose">
			<div class="body-img">
				<div id="qrcode" ref="qrcode"></div>
				<div style="text-align: center;height: 50px;line-height: 50px;border-radius: 10px;">请扫描上方二维码进行支付</div>
			</div>
			<!-- 	<vue-qr style="text-align: center;" :logoSrc="logoSrc" :correctLevel="3" :autoColor="false" colorDark="#313a90"   :text="url" :size="360" :margin="20" :whiteMargin='true' :logoMargin="3"></vue-qr> -->
			<!-- </div> -->
			<!-- 			  <div style="text-align: center;height: 50px;line-height: 50px;border-radius: 10px;">请扫描上方二维码进行支付</div> -->
		</rs-dialog>
	</div>
</template>

<script>
	import VueQr from 'vue-qr'
	import QRCode from 'qrcodejs2';
	import Http from "@/api/api";
	import API from "@/api/pay";
	import utils from "@/utils/utils";
	import Export2Excel from "@/utils/Export2Excel";
	import Blob from "@/utils/Blob";
	// import detail from "../resourceManage/resourceDetail";
	export default {
		name: "resourceManage",
		components: {
			QRCode,
			VueQr
		},
		data() {
			return {
				logoSrc: require('../assets/logo.png'),
				dialogVisibles: false,
				url: '',
				Type: [
					{
					  label:'待支付',
					tradeStatus:'WAIT'
					},
					{
					  label:'已支付',
					tradeStatus:'SUCCESS'
					},
					{
					  label:'部分付款',
					tradeStatus:'PART_PAID'
					},
					{
					  label:'超收',
					tradeStatus:'OVER_PAID'
					}
				],
				PayNum: 0,
				primaryButton: "primary",
				primary: "",
				primaryliushui: "",
				timeDefaultShow: [],
				pickerOptions: {
					shortcuts: [{
							text: "最近一周",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit("pick", [start, end]);
							},
						},
						{
							text: "最近一个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit("pick", [start, end]);
							},
						},
						{
							text: "最近三个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit("pick", [start, end]);
							},
						},
					],
				},
				showChangeTypeDialog: false,
				path: "",
				contractId: "",
				tableData: [],
				Contract: [],
				ccontractCode: [
					{
					  label:'扫码',
					  payType:'SM'
					},
					{
					  label:'对公',
					  payType:'QF'
					},
				],
				// wholeReceptiontabData: [],
				// wholeRecepData: [],
				// wholeRecepliushuiData: [],
				// tableColumns: [],

				// ruleForm: [],
				// tmpRuleForm: [],
				pageNum: 1,
				pageSize: 10,
				total: 0,
									beginDate: [],
				searchForm: {
					contractCode: "",

					shopId: "",
					boothCode: '',
					tradeStatus:''
				},
				searchFormClose: true,
				amountpaid: "",
				confirmType: "",
				dialogVisible: false,
				shopVo: {},
				updateTime: "",
				Currentnumber: "",
				PaidAmount: 0,
				categoryList: [],
				val: '',
				gettimes: '',
				nums: '',
				boothCode: ''
			};
		},
		watch: {
			searchMenuName(val) {
				console.log(val);
				this.$refs.resourceTree.filter(val);
			},
		},
		//生命周期 - 创建完成（访问当前this实例）
		created() {
			// let phone = utils.getSession("pay");
			// console.log(phone.shopVo.mallCode)
			this.bus.$on('id', (num) => {
				this.nums = num
			})
			this.bus.$on('val', (val) => {
				this.val = val
			})
			this.getTime();
			this.shopVo = sessionStorage.getItem("shopVo");
			// debugger
			let {
				auditStatusStr,
				mallCode
			} = this.$route.query;
			this.searchForm.auditStatusStr = auditStatusStr ? [1 * auditStatusStr] : [];
			this.searchForm.mallCode = mallCode || "";
			this.renderPage();
			if (
				this.$route.query.mallCode &&
				this.$route.query.contractStatus &&
				this.$route.query.days
			) {
				this.searchForm.contractStatusStr = Number(
					this.$route.query.contractStatus
				);
				this.searchForm.auditStatusStr = 2; //审核通过
				this.searchForm.mallCode = this.$route.query.mallCode;
				let days = Number(this.$route.query.days);
				if (this.$route.query.contractStatus == 4) {
					//待生效==查近期开始合同
					this.searchForm.beginDate =
						days > 0 ? [utils.dateFormatter(new Date()), this.getAfterParamsDate(days)] : [this
							.getAfterParamsDate(days), utils.dateFormatter(new Date())
						];
				} else if (this.$route.query.contractStatus == 1) {
					//已生效==查近期到期合同
					this.searchForm.endDates =
						days > 0 ? [utils.dateFormatter(new Date()), this.getAfterParamsDate(days)] : [this
							.getAfterParamsDate(days), utils.dateFormatter(new Date())
						];
				}
			}
		},
		//生命周期 - 挂载完成（访问DOM元素）
		mounted() {
			// this.handleQueryy()
			this.handleQuery();
			this.amountobepaid();
			this.Currentpayment();
			this.TotalPaidAmount();
		},
		activated() {
			this.handleQuery();
		},
		methods: {
			change(value){
				console.log(value)
				this.searchForm.transTimeStart=value[0]
				this.searchForm.transTimeEnd=value[1]
			},
			// formatCarModels(row, Status) {
			// 	let phone = utils.getSession("pay");
			// 	// console.log(phone)
			// 	if (row.mallCode == phone.shopVo.mallCode) {

			// 		return phone.shopVo.mallName;
			// 	} 
			// },
			// 列表API数据合同
			handleQueryy() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize: 999,
					pageNum,
					...this.searchForm,
					paidStatus: 0,
					businessId: this.shopVo,
				};
				params = this.turnParams(params);
				API.getPayRecordList(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							// this.tableData = res.data.data.list;
							// this.total = res.data.data.total;
							for (var i = 0; i < res.data.data.list.length; i++) {
								if (this.Contract.indexOf(res.data.data.list[i].contractCode) === -1) {
									this.Contract.push(res.data.data.list[i].contractCode)
								}
								if (
									this.ccontractCode.indexOf(res.data.data.list[i].booths) === -1 || res.data.data
									.list[i].booths !== null
								) {
									this.ccontractCode.push(res.data.data.list[i].booths);
									console.log(this.ccontractCode);
								}
							}
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			getTime() {
				let starttime = new Date(new Date().toLocaleDateString());
				let endtime = new Date();
				this.timeDefaultShow.push(starttime);
				this.timeDefaultShow.push(endtime);
			},
			// toDetails(id) {
			//   this.$openTabSwitch(
			//     "合同详情",
			//     `/contractNew?actionType=view&contractType=${this.contractType}&contractId=${id}&fromPath=versionList`
			//   );
			// },

			//待缴账单
			wholeReception(e) {
				console.log(e.target.innerHTML);
				localStorage.setItem("index", e.target.innerHTML);
				this.primaryButton = "primary";
				this.primary = "";
				this.primaryliushui = "";
				//待缴账单
				this.handleQuery();
				// this.tableData = this.wholeReceptiontabData;
			},
			//已缴账单
			wholeRecep(e) {
				console.log(e.target.innerHTML);
				localStorage.setItem("index", e.target.innerHTML);
				this.primaryButton = "";
				this.primary = "primary";
				this.primaryliushui = "";
				//已缴账单
				this.getTotalPaidAmount();
				// this.tableData = this.wholeRecepData;
			},
			//缴费流水
			wholeRecepliushui(e) {
				console.log(e.target.innerHTML);
				localStorage.setItem("index", e.target.innerHTML);
				this.primaryButton = "";
				this.primary = "";
				this.primaryliushui = "primary";
				//缴费流水
				this.getPayRecordList();
				// this.tableData = this.wholeRecepliushuiData;
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map((v) => {
					switch (v.tradeStatus) {
						case "WAIT":
							v.tradeStatus = "待支付";
							break;
						case "SUCCESS":
							v.tradeStatus = "支付成功";
							break;
						case "PART_PAID":
							v.tradeStatus = "部分付款";
							break;
						case "OVER_PAID":
							v.tradeStatus = "超收";
							break;
					}

					switch (v.verifyStatus) {
						case "0":
							v.verifyStatus = "未对账";
							break;
						case "1":
							v.verifyStatus = "对账成功";
							break;
						case "2":
							v.verifyStatus = "对账异常";
							break;
						case "3":
							v.verifyStatus = "自动修改";
							break;
					}
					switch (v.payType) {
						case "SM":
							v.payType = "扫码";
							break;
						case "QF":
							v.payType = "对公";
							break;
					}
					return filterVal.map((j) => v[j]);
				});
			},
			export2Excel() {
				require.ensure([], () => {
					const {
						export_json_to_excel
					} = require("../../../utils/Export2Excel"); //调用excel.js
					//头部
					const tHeader = [
						"铺位号",
						"楼栋",
						"楼层",
						"支付金额",
						"订单流水号",
						"支付方式",
						"付款账户",
						"收款账户",
						"交易状态",
						'对账状态',
						"支付时间",
					];
					//内容
					const filterVal = [
						"booths",
						"buildings",
						"floors",
						"payAmt",
						"merOrderNo",
						"payType",
						"chl_sub_act_no ",
						"account_number",
						"tradeStatus",
						'verifyStatus',
						"transTime",
					];
					const list = this.tableData;
					console.log(list);
					const data = this.formatJson(filterVal, list);
					export_json_to_excel(tHeader, data, "对账缴费信息表");
				});
			},
			//

			getAfterParamsDate(params) {
				let date = new Date().getTime() + 24 * 60 * 60 * 1000 * params;
				date = utils.dateFormatter(date);
				return date;
			},
			// 查询
			handleSearch() {
				var num = 1
				this.bus.$emit('id', num)
				this.pageNum = 1;
				console.log(this.searchForm);
				this.handleQuery();
			
			},
			boothCodes() {
				this.boothCode = this.searchForm.boothCode
			},
			clear() {
				this.beginDate=[]
				this.searchForm={}
				this.handleQuery()
			},
			handleQuerys() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					// ...this.searchForm,
					paidStatus: 0,
					businessId: this.shopVo,
				};
				params = this.turnParams(params);
				API.getPayRecordList(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
							for (var i = 0; i < this.tableData.length; i++) {
								if (
									this.Contract.indexOf(this.tableData[i].contractCode) === -1
								) {
									this.Contract.push(this.tableData[i].contractCode);
								}
								if (
									this.ccontractCode.indexOf(this.tableData[i].boothCode) === -1
								) {
									this.ccontractCode.push(this.tableData[i].boothCode);

									// console.log(this.ccontractCode);
								}
							}
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			formatCarModelsss(row, Status) {
				if (row.payType == "SM") {
					return "扫码";
				} else if (row.payType == 'QF') {
					return "对公";
				}
			},
			formatCarModels(row, Status) {
				if (row.tradeStatus == "WAIT") {
					return "未支付";
				} else if (row.tradeStatus == 'SUCCESS') {
					return "已支付";
				} else if (row.tradeStatus == 'PART_PAID') {
					return '部分付款'
				} else if (row.tradeStatus == 'OVER_PAID') {
					return '超收'
				}
			},
			formatCarModelss(row, Status) {
				if (row.verifyStatus == "0") {
					return "未对账";
				} else if (row.verifyStatus == '1') {
					return "对账成功";
				} else if (row.verifyStatus == '2') {
					return '对账异常'
				} else if (row.verifyStatus == '3') {
					return '自动修改'
				} else if (row.verifyStatus == '4') {
					return '自动修改失败'
				}
			},
			// 列表API数据
			handleQuery() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					paidStatus: 0,
					businessId: this.shopVo,
					
				};
				params = this.turnParams(params);
				API.getPayRecordList(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			turnParams(params) {
				console.log(params);
				if (params.beginDate && params.beginDate.length) {
					params.paymentDueBeginDate =
						typeof params.beginDate[0] == "object" ?
						utils.dateFormatter(params.beginDate[0], "yyyy-MM-dd") :
						params.beginDate[0];
					params.paymentDueEndDate =
						typeof params.beginDate[1] == "object" ?
						utils.dateFormatter(
							typeof params.beginDate[1] == "object" ?
							params.beginDate[1] :
							new Date(params.beginDate[1]),
							"yyyy-MM-dd"
						) :
						params.beginDate[1];
				} else {
					params.paymentDueBeginDate = "";
					params.paymentDueEndDate = "";
				}
				delete params.beginDate;
				if (params.endDates && params.endDates.length) {
					params.beginDate =
						typeof params.endDates[0] == "object" ?
						utils.dateFormatter(params.endDates[0], "yyyy-MM-dd") :
						params.endDates[0];
					params.endDate =
						typeof params.endDates[1] == "object" ?
						utils.dateFormatter(params.endDates[1], "yyyy-MM-dd") :
						params.endDates[1];
				} else {
					params.beginDate = "";
					params.endDate = "";
				}
				delete params.endDates;
				console.log(params);
				return params;
			},

			//获取已缴费清单
			getTotalPaidAmount() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				console.log(this.shopVo);
				// console.log(this.shopVo.shopId)
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					paidStatus: 1,
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},

			//获取未缴费清单  （未缴费加上一个月时间）
			Bills() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				console.log(this.shopVo);
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					// businessId: this.shopVo,
					businessId: this.shopVo,
					// paidStatus:0,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},

			//缴费流水
			getPayRecordList() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					paidStatus: 0,
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.getPayRecordList(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},

			//获取待缴费金额
			amountobepaid() {
				let params = {
					businessId: this.shopVo,
					paymentDueBeginDate: "",
					paymentDueEndDate: "",
					paidStatus: 0,
					contractCode: this.searchForm.contractCode,
				};

				API.paygetTotalUnpaidAmount(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						if (res.data.data == null) {
							this.amountpaid = 0
						} else {
							this.amountpaid = res.data.data;
						}

					}
				});
			},

			addDate() {
				// const nowDate = new Date();
				// const date = {
				//   year: nowDate.getFullYear(),
				//   month: nowDate.getMonth() + 2,
				//   date: nowDate.getDate(),
				// };
				// const newmonth = date.month > 10 ? date.month : "0" + date.month;
				// const day = date.date > 10 ? date.date : "0" + date.date;
				// const hh = new Date().getHours();
				// const mf = new Date().getMinutes()
				// const ss = new Date().getSeconds()
				var _this = this;
				// let yy = new Date().getFullYear();
				// let mm = new Date().getMonth()+1;
				// let dd = new Date().getDate();
				// let hh = new Date().getHours();
				// let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
				// let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
				var d = new Date();
				var ye = d.getFullYear();
				var mo = (d.getMonth() + 2).toString().padStart(2, "0");
				var mos = (d.getMonth() + 1).toString().padStart(2, "0");
				var da = d.getDate().toString().padStart(2, "0");
				var updateTime = ye + "-" + mo + "-" + da;
				var updateTimes = ye + "-" + mos + "-" + da;
				// alert(time);
				// _this.updateTime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
				_this.updateTime = updateTime;
				_this.gettimes = updateTimes
				console.log(updateTime);

				// this.updateTime = date.year + "-" + newmonth + "-" + day + '' + hh;
			},

			//获取当期缴费金额   当前时间加一个月
			Currentpayment() {
				this.addDate();
				let updateTime = this.updateTime;
				let updateTimes = this.gettimes
				console.log(updateTime);
				// let time = Number(updateTime)
				// console.log(time)
				let params = {
					businessId: this.shopVo,
					paymentDueBeginDate: updateTimes,
					paymentDueEndDate: updateTime,
					contractCode: this.searchForm.contractCode,
				};

				API.paygetTotalUnpaidAmount(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						this.Currentnumber = res.data.data;
					}
				});
			},

			//获取已缴费金额
			TotalPaidAmount() {
				let params = {
					...this.searchForm,
					paidStatus: 1,
					businessId: this.shopVo,
				};

				API.getTotalPaidAmount(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						if (res.data.data == null) {
							this.PaidAmount = 0;
						} else {
							this.PaidAmount = res.data.data;
						}
					}
				});
			},

			//获取
			handleSelectionChange(val) {
				this.bus.$emit('val', val)
				this.multipleSelection = val;
				console.log(this.multipleSelection);
				var categorystr = "";
				var classifystr = "";
				var classirerstr = "";
				this.multipleSelection.forEach(function(c) {
					categorystr += c.statementNo + ",";
					classifystr += c.itemCode + ",";
					classirerstr += c.businessId + ",";
				});
				categorystr = categorystr.substring(0, categorystr.length - 1);
				console.log(categorystr);
				classifystr = classifystr.substring(0, classifystr.length - 1);
				classirerstr = classirerstr.substring(0, classirerstr.length - 1);
				// this.categoryList = categorystr.split(",");
				// this.classifystr = classifystr.split(",");
				// this.classirerslist = classirerstr.split(",");
				this.categoryList = categorystr;
				this.classifystr = classifystr;
				this.classirerslist = classirerstr;
				// console.log(str)
				console.log(this.categoryList);
				console.log(this.classifystr);
				console.log(this.classirerslist);
			},
			handleClose(done) {
				this.$confirm('确认取消支付？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},

			//生成·二维码
			qrcodeScan() {
				//清楚上次生成二维码
				this.$refs.qrcode.innerHTML = ''
				let qrcode = new QRCode('qrcode', {
					text: this.url,
					width: 150,
					height: 150,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H,
				})
			},
			//缴费确认
			confirmation() {
				if (this.val.length == 0) {
					this.$message.error('您还未勾选需要缴费信息')
				} else {
					let params = {
						statementNo: this.categoryList,
						itemCode: this.classifystr,
						businessId: '407',
					};
					API.unifiedPreOrder7011(params).then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.dialogVisibles = true,
								this.url = res.data.data.js_pay_url
							this.$nextTick(() => {
								this.qrcodeScan()
							})
							// window.open(res.data.data.pc_cashier_url);
							let params = {
								merOrderNo: res.data.data.merOrderNo,
							};
							API.getPayRecordByMerOrderNo(params).then((res) => {
								if (res.data.code == 200) {
									console.log("获取合同列表", res);
								}
							});
						} else {}
					});
				}

			},

			// 查看
			handleView(row) {
				console.log(row);
				// if (!this.$btnResource()["zyht-ck"]) {
				//   this.$message.warning("暂无查看权限");
				//   return;
				// }
				// this.$openTabSwitch(
				//   "自营合同详情",
				//   `/contractNew?actionType=view&contractType=norm&contractId=${row.id}&fromPath=contractList`
				// );
				// this.$router.push({path: '/contract', query: {actionType:'view',contractType:'norm',contractId:row.id}})
			},
			// 历史版本
			// toVersion(scope) {
			//   this.$openTabSwitch(
			//     "自营合同历史版本",
			//     `/versionList?contractType=norm&contractCode=${scope.row.contractCode}&fromPath=contractList`
			//   );
			// },
			// 退租
			// toTuizu(scope) {
			//   this.$openTabSwitch(
			//     "自营合同退租",
			//     `/tuizu?contractType=norm&contractCode=${scope.row.contractCode}&fromPath=contractList&id=${scope.row.id}`
			//   );
			// },
			// 合同终止
			// toStop(scope) {
			//   let { id } = scope.row;
			//   this.$openTabSwitch(
			//     "自营合同终止",
			//     `/refundEdit?contractId=${id}&jumpType=add`
			//   );
			// },
			// 新增
			// handleCreate(scope, actionType, typeName) {
			//   let id = scope ? scope.row.id : "",
			//     contractCode = scope ? scope.row.contractCode : "";
			//   let title = `${typeName}自营合同`;
			//   if (actionType == "renew") {
			//     this.$openTabSwitch(
			//       title,
			//       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}&correlationContractId=${id}&correlationContractCode=${contractCode}`
			//     );
			//   } else if (actionType == "stop") {
			//     this.$openTabSwitch(
			//       title,
			//       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}&correlationContractId=${id}&correlationContractCode=${contractCode}`
			//     );
			//   } else {
			//     this.$openTabSwitch(
			//       title,
			//       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}`
			//     );
			//   }
			// },
			// 审核
			// toApply(flowNo) {
			//   this.$getZjBpmViewUrl(flowNo);
			//   // this.$openTabSwitch2(
			//   //   "",
			//   //   `/workflow/#/flowDetail?processInstanceId=${id}&isBack=true`
			//   // );
			// },
			// 删除  作废
			// openDialog(scope, type) {
			//   this.contractId = scope.row.id;
			//   this.confirmType = type;
			//   this.dialogVisible = true;
			// },
			// 删除  作废  confirm
			async confirm() {
				let res = null;
				if (this.confirmType == "删除") {
					res = await API.delete({
						id: this.contractId
					});
				} else if (this.confirmType == "作废") {
					res = await API.cancel({
						id: this.contractId
					});
				}
				if (res.data.code == 200) {
					this.dialogVisible = false;
					this.handleQuery();
					this.$message.success(`${this.confirmType}成功`);
				}
			},

			handleSizeChange(val) {
				this.pageSize = val;
				this.handleQuery();
			},
			handleCurrentChange(val) {
				this.pageNum = val;
					this.handleQuery()
			
			},
			changeSearchFormClose() {
				this.searchFormClose = !this.searchFormClose;
				if (this.searchFormClose) {
					this.ruleForm = this.ruleForm.filter((item) => {
						return !item.allowHide;
					});
				} else {
					this.ruleForm = this.tmpRuleForm;
				}
			},
			mallChange(val) {
				// console.log(val )
				this.$set(this.searchForm, "mallCode", val.mallCode);
				this.$set(this.searchForm, "mallName", val.mallName);
				this.handleQuery();
			},
			changeFloor(val) {
				// console.log(val);
				this.searchForm.buildingId = _.uniq(
					val.map((item) => item.buildingId)
				)[0];
				this.searchForm.floorId = _.uniq(val.map((item) => item.floorId))[0];
			},

			// 渲染搜索条件和table
			renderPage() {
				this.tmpRuleForm = [
					// {
					// 	slot: "mallName",
					// },
					{
						slot: "ccontractCode",
					},
					{
						slot: "type",
						// sortable: true,
					},
					{
						slot: "date",
						// allowHide:true
					},
				];
				this.ruleForm = this.tmpRuleForm.filter((item) => {
					return !item.allowHide;
				});
				this.tableColumns = [{
						width: 40,
						type: "selection",
						fixed: true,
					},

					{
						align: "center",
						type: "index",
						label: "序号",
						minWidth: "50px",
						// sortable: true,
					},
					// {
					// 	slot:'mallCode'
					// },

					{
						align: "center",
						prop: "booths",
						label: "铺位号",
						minWidth: "120px",
						// sortable: true,
					},
					{
						align: "center",
						prop: "buildings",
						label: "楼栋",
						minWidth: "120px",
						// sortable: true,
					},
					{
						align: "center",
						prop: "floors",
						label: "楼层",
						minWidth: "120px",
						// sortable: true,
					},
					// {
					// 	align:"center",
					// 	label:'收单渠道',
					// 	prop:''
					// },
					{
						slot: 'payAmt'
					},
					// {
					// 	align:"center",
					// 	label:'缴费类型',
					// 	prop:''
					// },
					{
						align: "center",
						label: '订单流水号',
						prop: 'merOrderNo'
					},
					// {
					// 	align:"center",
					// 	label:'付款流水号',
					// 	prop:'',
					// 	minWidth: "120px",
					// },
					{
						align: "center",
						prop: "payType",
						label: "支付方式",
						minWidth: "120px",
						// sortable: true,
					},
					{
						align: "center",
						prop: "chl_sub_act_no",
						label: "付款账户",
						minWidth: "120px",
						// sortable: true,
					},
					{
						align: "center",
						prop: "account_number",
						label: "收款账户",
						minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'tradeStatus'
					},
					{
						slot: 'type'
					},
					{
						align: "center",
						prop: "transTime",
						label: "支付时间",
						minWidth: "120px",
						// sortable: true,
					},
					// {
					// 	align:"center",
					// 	prop: "itemName",
					// 	label: "费用项",
					// 	minWidth: "120px",
					// 	// sortable: true,
					// },
					// {
					// 	slot: "contractCode",
					// },
				];
			},
		},
	};
</script>
<style lang="less" scoped>
	@import "../../organizationManage/style/index.less";

	/deep/ .rs-table__row {
		&:hover {
			cursor: pointer;
		}
	}

	/deep/ .current-row {
		.resourceCode {
			color: #2ba3ff;
		}
	}

	.contractCode {
		height: 90px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-around;
		background: #f3f7ff;
	}

	.contractCode div {
		text-align: center;
		line-height: 2;
		font-size: 16px;
		margin: 5px;
	}

	.contractCodecolor {
		color: burlywood;
		font-size: 16px;
	}

	.contractCodecolor span {
		font-size: 14px;
	}

	.rs-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.bg-purple-dark {
		background-color: #ffffff;
		color: black;
		font-weight: bold;
		font-size: 15px;
		padding-left: 20px;
		display: flex;
		align-items: center;
	}

	.grid-content {
		/* border-radius: 4px; */
		height: 40px;
		line-height: 40px;
	}

	.main {
		margin-top: 10px;
		padding: 10px;
	}

	.container {
		height: 100%;
		// background-color: #ebebeb;
	}

	.main_header {
		background: white;
		padding: 10px;
		box-shadow: 2px 2px 10px #909090;
	}

	#qrcode {
		width: 150px;
		height: 150px;
		margin: 0 auto;
	}

	#qrcode canvas+img {
		width: 100%;
		height: 100%;
		border-radius: ;
		cursor: pointer;
	}

	.rs-popover__reference {
		display: none;
	}
</style>
